import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting, AiOutlineWhatsApp, AiOutlineInstagram, AiOutlineShareAlt } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine, RiTelegramLine } from 'react-icons/ri';
import { FaAward, FaTelegramPlane } from 'react-icons/fa';
import { BsTelegram } from 'react-icons/bs';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import OneUser from '../ones/OneUser';
import SwipeTabs from '../components/SwipeTabs';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ recentPlayers, setRecentPlayers ] = useState([]);
  const [ searchTerm, setSearchTerm ] = useState('');
  const [ searchResults, setSearchResults ] = useState([]);
  const [ searching, setSearching ] = useState(false);

  const getRecentPlayers = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-recent-players', { }).then(response => {
        if(response.status === 1) {
          setRecentPlayers(response.recentPlayers);
          resolve();
        } else {
          appContext.tellError(response.msg);
        }
      })
    })
  }

  const getSearchResults = (_searchTerm) => {
    return new Promise(async resolve => {
      if(_searchTerm.trim().length > 0) {
        setSearching(true);
        await callGameServerApi('get-player-search-results', { searchTerm: _searchTerm }).then(response => {
          setSearching(false);
          if(response.status === 1) {
            setSearchResults(response.searchResults);
            resolve();
          } else {
            resolve(false)
            appContext.tellError(response.msg);
          }
        })
      } else  {
        resolve(false)
      }
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getRecentPlayers().then( async () => {
      setReady(true);
    })
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    getSearchResults(searchTerm);
  }, [ searchTerm ])

  if(ready) {
    return (
      <>
        <TopBar title="Discover Players"/>
        <div className="FullPane" id='_fullPane1'  data-support-top-bar={true} style={{ paddingBottom: "var(--topBarheight)" }}>
          <SwipeTabs
            tabs={[
              {
                id: 'recent_players',
                title: 'Recent',
                view: (
                  <div className="container-fluid">
                    {
                      (recentPlayers.length > 0) ?
                      recentPlayers.map((item, i) => {
                        return (
                          <OneUser key={i} id={item.id} />
                        )
                      }):
                      <h6 className="text-muted">No players were found</h6>
                    }
                  </div>
                ),
              },
              {
                id: 'search_players',
                title: 'Search',
                view: (
                  <div className="container-fluid">
                    <div className='form-group'>
                      <input className='form-control' placeholder='Search user here' onChange={(e) => setSearchTerm(e.target.value.trim())}/>
                    </div>
                    {
                      (searchResults.length > 0) ?
                      searchResults.map((item, i) => {
                        return (
                          <OneUser key={i} username={item.username} id={item.id} />
                        )
                      })
                      :
                      <>
                      {
                        (searching) ? 
                        <div className='text-start support-loading'>
                          {getInlineLoader()}
                        </div>
                        :
                        <>
                        {
                          (searchTerm) ?
                          <h6 className="text-muted">No players were found</h6>
                          :
                          ""
                        }
                        </>
                      }
                      </>
                    }
                  </div>
                ),
              }
            ]}
          />
          
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
